// Module
var code = "<h1 id=\"桌面app开发\">桌面app开发</h1> <h2 id=\"electron\">Electron</h2> <ul> <li><a href=\"http://www.electronjs.org/\">官方文档</a></li> </ul> <h2 id=\"nwjs\">NW.JS</h2> <ul> <li><a href=\"https://nwjs.org.cn/\">官方文档</a></li> </ul> ";
// Exports
module.exports = code;